import { Injectable } from '@angular/core';
import { AI_CONTRACT_CLASSES } from './chat-html-contract';
import { ChatInlineContentNormalizer } from './chat-inline-content-normalizer';
import { ChatSemanticStructureNormalizer } from './chat-semantic-structure-normalizer';

export { AI_CONTRACT_CLASSES } from './chat-html-contract';

/** Normalizes already-sanitized LLM markup into the canonical chat answer contract. */
@Injectable({ providedIn: 'root' })
export class ChatHtmlTranslatorService {
  private readonly structure = new ChatSemanticStructureNormalizer(
    new ChatInlineContentNormalizer()
  );

  translate(sanitizedHtml: string): string | null {
    return this.structure.translate(sanitizedHtml);
  }
}
